export const SSO_FLOW_COOKIE = 'elowen_sso';
export const SSO_FLOW_TTL_SECONDS = 600;

// Module-local: the list only backs `SsoErrorCode` and the narrowing below. Callers take the type.
const SSO_ERROR_CODES = [
  'no_account',
  'denied',
  'already_linked',
  'directory_unavailable',
  'tenant_mismatch',
  'state_expired',
  'not_setup',
  'sso_failed',
] as const;

export type SsoErrorCode = (typeof SSO_ERROR_CODES)[number];

const SAME_ORIGIN_PROBE = 'https://same-origin.invalid';

/** Accept only a same-origin path. The value is resolved the way a browser resolves a Location header:
 * the URL parser drops tabs and newlines and turns backslashes into slashes, so `/\t/host` or `/\host`
 * would otherwise become `//host`. A value is accepted only when that resolution keeps the origin. */
export function safeSsoNext(value: string | null | undefined): string {
  if (!value || !value.startsWith('/')) return '/';
  return new URL(value, SAME_ORIGIN_PROBE).origin === SAME_ORIGIN_PROBE ? value : '/';
}

export function ssoErrorCode(value: unknown): SsoErrorCode {
  if (value === 'guest') return 'denied';
  return typeof value === 'string' && (SSO_ERROR_CODES as readonly string[]).includes(value)
    ? value as SsoErrorCode
    : 'sso_failed';
}
